export class DataImport {
    id: string;
    thingId: string;
    dateTime: number;
    state: DataImportState;
    creationTimestamp: number;
    lastUpdateTimestamp: number;
    name: string;
    url: string;
    totalCount: number;
    importedCount: number;
    remainingSeconds: number;
    unrecognizedColumns: string[];
}

export enum DataImportState {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}